"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionRenderer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const quiz_1 = require("../../../model/quiz");
const single_choice_question_renderer_1 = require("./single-choice-question-renderer");
const material_1 = require("@mui/material");
const log_context_1 = require("../../../context/log-context");
const log_1 = require("../../../model/log");
const audio_button_1 = require("../../../component/audio/audio-button");
const QuestionRendererInner = (0, react_1.memo)(({ question, onAnswerChange, sx, userAnswerState, }) => {
    const { logEvent } = (0, log_context_1.useLog)();
    const contentRenderer = (0, react_1.useMemo)(() => {
        switch (question.type) {
            case quiz_1.QuestionType.SingleChoice:
                return ((0, jsx_runtime_1.jsx)(single_choice_question_renderer_1.SingleChoiceQuestionRenderer, { question: question, onAnswerChange: onAnswerChange, userAnswerState: userAnswerState }));
            default:
                return null;
        }
    }, [onAnswerChange, question, userAnswerState]);
    const handlePlayStateChange = (0, react_1.useCallback)((playing) => {
        if (playing) {
            logEvent(log_1.LogEventType.Click, log_1.LogEventClickName.QuizQuestionAudioPlay);
        }
        else {
            logEvent(log_1.LogEventType.Click, log_1.LogEventClickName.QuizQuestionAudioPause);
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { spacing: 2, sx: sx, children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h6", children: question.title }), question.audioUrl && ((0, jsx_runtime_1.jsx)(audio_button_1.AudioButton, { audioUrl: question.audioUrl, onPlayStateChange: handlePlayStateChange }))] }), contentRenderer] }));
});
QuestionRendererInner.displayName = "QuestionRenderer";
exports.QuestionRenderer = QuestionRendererInner;
